const INGREDIENT_KEYWORD_COLUMN_ALLOWED_OPERATIONS = {
  ADD: 'ADD',
  RENAME: 'RENAME',
  DELETE: 'DELETE',
  ASSIGN_LANGUAGE: 'ASSIGN_LANGUAGE',
  MOVE_COLUMN: 'MOVE_COLUMN',
  TRANSFER: 'TRANSFER',
}

export default INGREDIENT_KEYWORD_COLUMN_ALLOWED_OPERATIONS
